export enum EFiscalEnvironment {
  Homologation = 0,
  Production = 1,
}
